import { createSelector } from 'reselect'

export const selectOrganizationsManagementState = state => state.organizationsManagement

export const selectOrganizationsInitialized = createSelector(
  selectOrganizationsManagementState,
  data => data.initialized
)

export const selectOrganizationsSave = createSelector(
  selectOrganizationsManagementState,
  data => data.save
)

export const selectOrganizationsErrors = createSelector(
  selectOrganizationsManagementState,
  data => data.errors
)

export const selectOrganizationsGeneral = createSelector(
  selectOrganizationsManagementState,
  data => data.general
)

export const selectOrganizationsRoutes = createSelector(
  selectOrganizationsManagementState,
  data => data.routes
)

export const selectOrganizationsSelectedProvider = createSelector(
  selectOrganizationsManagementState,
  data => data.selectedProvider
)

export const selectOrganizationsSelectedOffer = createSelector(
  selectOrganizationsManagementState,
  data => data.selectedOffer
)

export const selectOrganizationsViewParameters = createSelector(
  selectOrganizationsManagementState,
  data => data.viewParameters
)

export const selectOrganizationsComparators = createSelector(
  selectOrganizationsManagementState,
  data => data.comparators
)
